import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="toast-container">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="toast" [class]="'toast--' + toast.type">
          <mat-icon class="toast-icon" fontSet="material-icons-outlined">{{ iconFor(toast.type) }}</mat-icon>
          <span class="toast-message">{{ toast.message }}</span>
          <button class="toast-close" (click)="toastService.dismiss(toast.id)">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
          </button>
        </div>
      }
    </div>
  `,
  styles: `
    .toast-container {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: none;
    }

    .toast {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 16px;
      border-radius: var(--nf-radius);
      background: var(--nf-surface-elevated);
      border: 1px solid var(--nf-border);
      box-shadow: var(--nf-shadow-lg);
      min-width: 280px;
      max-width: 400px;
      pointer-events: auto;
      animation: toastSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    @keyframes toastSlideIn {
      from { opacity: 0; transform: translateX(100%); }
      to   { opacity: 1; transform: translateX(0); }
    }

    .toast-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    .toast--success .toast-icon { color: var(--nf-success); }
    .toast--error   .toast-icon { color: var(--nf-danger); }
    .toast--info    .toast-icon { color: var(--nf-info); }
    .toast--warning .toast-icon { color: var(--nf-warning); }

    .toast-message {
      flex: 1;
      font-size: 14px;
      color: var(--nf-text);
    }

    .toast-close {
      background: none;
      border: none;
      cursor: pointer;
      color: var(--nf-text-muted);
      padding: 2px;
      display: flex;
      border-radius: 4px;
      transition: color var(--nf-transition);

      &:hover { color: var(--nf-text); }

      mat-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
    }
  `,
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);

  protected iconFor(type: Toast['type']): string {
    const map: Record<Toast['type'], string> = {
      success: 'check_circle',
      error: 'error',
      info: 'info',
      warning: 'warning',
    };
    return map[type];
  }
}
